import React from 'react';
import IconCard from '../../../../components/IconCard';
import type { ThemeProps } from '..';

import './style.scss';

const ThemeTeaser: React.FC<ThemeProps> = (props) => {
  const {
    entity,
    menuTeaser,
    isDesktop,
    onClick,
  } = props;

  const taxonomyTerm = entity.toJS();
  const teaserName = taxonomyTerm.field_teaser_title?.[0]?.value || taxonomyTerm.name[0].value;
  const name = isDesktop ? teaserName : taxonomyTerm.name[0].value;
  const linkUri = taxonomyTerm.paths.nl;
  const description = taxonomyTerm.field_short_description?.[0]?.value;
  const image = taxonomyTerm.field_media_image[0].source;
  const iconAlt = taxonomyTerm.field_media_image[0].alt || '';

  return (
    <IconCard
      title={name}
      description={!menuTeaser ? description : ''}
      richText
      icon={image}
      iconAlt={iconAlt}
      href={linkUri}
      onClick={onClick}
    />
  );
};

export default ThemeTeaser;
